import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=06581fca"
import script from "./pool.vue?vue&type=script&lang=js"
export * from "./pool.vue?vue&type=script&lang=js"
import style0 from "./pool.vue?vue&type=style&index=0&id=06581fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports